'use client'

import { useTranslations } from 'next-intl'

import { contentDesignFormConfig } from '@/content-from-sections/client'

import { ContentForm } from '../../ContentForm'
import {
	ImagesField,
	imagesInfoFormConfig,
	qrNameFormConfig,
	shareImagesFormConfig,
	TQrContentFormSection,
	welcomeScreenFormConfig,
} from '../../contentFormSections'
import { QR_TYPE, TContentFormProps } from '../../generatorTypes'

export const ImagesContentForm = (props: TContentFormProps) => {
	const t = useTranslations()

	const config = {
		formSectionList: [
			contentDesignFormConfig(t, ImagesField),
			imagesInfoFormConfig(t),
			shareImagesFormConfig(t),
			welcomeScreenFormConfig(t),
			qrNameFormConfig(t),
		] satisfies TQrContentFormSection[],
	}

	return <ContentForm qrType={QR_TYPE.Images} config={config} {...props} />
}
